import { render, staticRenderFns } from "./RelatieContractAfspraken.vue?vue&type=template&id=437875d5"
import script from "./RelatieContractAfspraken.vue?vue&type=script&lang=js"
export * from "./RelatieContractAfspraken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports